import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  href?: string;
  onClick?: () => void;
  className?: string;
  type?: 'button' | 'submit';
}
export function Button({
  children,
  variant = 'primary',
  href,
  onClick,
  className = '',
  type = 'button'
}: ButtonProps) {
  const baseStyles = 'px-6 py-3 rounded-lg font-semibold transition-all duration-300 inline-flex flex-row items-center justify-center gap-2 min-h-[44px] relative overflow-hidden group';
  const variants = {
    primary: 'bg-gradient-to-r from-yellow-400 to-yellow-500 text-black shadow-[0_0_20px_rgba(252,211,77,0.3)] hover:shadow-[0_0_30px_rgba(252,211,77,0.5)]',
    secondary: 'border-2 border-yellow-400 text-yellow-400 hover:bg-yellow-400 hover:text-black'
  };
  const combinedClassName = `${baseStyles} ${variants[variant]} ${className}`;
  const content = <>
      {variant === 'primary' && <motion.div className="absolute inset-0 bg-gradient-to-r from-yellow-300 to-yellow-400" initial={{
      x: '-100%'
    }} whileHover={{
      x: 0
    }} transition={{
      duration: 0.3
    }} data-id="element-24" />}
      <span className="relative z-10 flex flex-row items-center gap-2" data-id="element-25">
        {children}
      </span>
    </>;
  if (href) {
    return <motion.a href={href} target="_blank" rel="noopener noreferrer" className={combinedClassName} whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.95
    }} data-id="element-26">
        {content}
      </motion.a>;
  }
  return <motion.button type={type} onClick={onClick} className={combinedClassName} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} data-id="element-27">
      {content}
    </motion.button>;
}